import { motion } from "framer-motion"
import { Link, useNavigate } from "react-router-dom"
import appStore from "../shared/assets/images/app-store.svg"
import googlePlay from "../shared/assets/images/google-play.svg"
import { fadeDown, fadeIn, fadeUp, staggerContainer } from "../shared/lib/motion"
import { useLanguage } from "../shared/context/LanguageContext"

export function DownloadApp() {
    const { translation: t } = useLanguage()
    const navigate = useNavigate()

    return (
        <motion.main
        variants={fadeIn}
        initial="hidden"
        whileInView="show"
        className="flex flex-col w-full h-[calc(100vh-70px)] items-center justify-center"
        viewport={{ once: true, amount: 0.3 }}
        >
            <motion.div className="container mx-auto md:px-4" variants={staggerContainer(0.1, 0.05)}>
                    <motion.div className="flex items-center justify-center mb-10" variants={fadeDown}>
                        <img src="/logos/logo.svg" alt="NowPay" className="h-8 md:h-[3.25rem] w-auto" />
                    </motion.div>
                    <div className="max-w-3xl mx-auto text-center">
                    <motion.h2 className="text-xl md:text-3xl font-bold text-primary mb-1 md:mb-2" variants={fadeUp}>
                        {t.downloadTitle}
                    </motion.h2>
                    <motion.h2 className="text-base md:text-xl font-medium text-primary/70 mb-6 md:mb-11" variants={fadeUp}>
                        {t.chooseTheStore}
                    </motion.h2>

                    <motion.div className="flex flex-col md:flex-row items-center justify-center gap-6 mb-2 md:mb-4" variants={staggerContainer(0.08, 0.04)}>
                        {/* App Store */}
                        <motion.div variants={fadeUp}>
                            <Link
                                to="https://apps.apple.com/sa/app/nowpay-saudi/id6739978824"
                                target="_blank"
                                rel="noopener noreferrer"
                                className="hover-lift"
                            >
                                <img src={appStore} alt="appStore" className="hover-scale" />
                            </Link>
                        </motion.div>
                        <motion.div variants={fadeUp}>
                            <Link
                                to="https://play.google.com/store/apps/details?id=com.nowpay.nowpayksa&pli=1"
                                target="_blank"
                                rel="noopener noreferrer"
                                className="hover-lift"
                            >
                                <img src={googlePlay} alt="googlePlay" className="hover-scale" />
                            </Link>
                        </motion.div>
                    </motion.div>

                    <motion.button
                        className="text-base md:text-lg font-medium text-primary/70 underline hover:text-hoverColor transition-colors"
                        variants={fadeUp}
                        onClick={() => navigate("/")}
                    >
                        {t.backToHome}
                    </motion.button>
                </div>
            </motion.div>
        </motion.main>
    )
}